export const UPDATE_MEDIAS = 'media/UPDATE_MEDIAS'
export const UPDATE_MEDIA_ID_LIST = 'media/UPDATE_MEDIA_ID_LIST'

export const UPDATE_CURRENT_MEDIA = 'news/UPDATE_CURRENT_MEDIA'